import React from 'react'
import { View, Pressable, StyleSheet } from 'react-native'

import { DS } from '@/design-system'

import * as cth from '@/router/(root)/cth/cthModule'
import * as d10 from '@/router/(root)/daily10/d10Module'
import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'

import type { MinigameModule } from '@/types/minigameModule'


function D10AdminControls(){
  return (
    <AdminControls m={d10} />
  )
}

function PocketPickAdminControls(){
  return (
    <AdminControls m={pocketPick} />
  )
}

function CthAdminControls(){

  return (
    <AdminControls m={cth} />
  )
}


function AdminControls({ m }: { m: MinigameModule }) {

  const handleTestingReset = m.useHandleTestingReset()
  const handleSeedLeaderboard = m.useHandleSeedLeaderboard()
  const handleClearLeaderboardSeeds = m.useHandleClearLeaderboardSeeds()
  //const handleGenerateDeal = m.useHandleGenerateDeal()

  const setTheme = m.useStore(s => s.setTheme)

  return (
    <>
    <View style={styles.adminRow}>

      <DS.Text variant="Body Large/Regular" color="Brand/Dark Grey">
        Testing:{' '}
      </DS.Text>

      <Pressable onPress={handleTestingReset}>
        <DS.Text variant="Body Large/Regular" color="Brand/Blue">
          Reset
        </DS.Text>
      </Pressable>

      <Pressable onPress={handleSeedLeaderboard}>
        <DS.Text variant="Body Large/Regular" color="Brand/Blue">
          Seed LB
        </DS.Text>
      </Pressable>
      
      <Pressable onPress={handleClearLeaderboardSeeds}>
        <DS.Text variant="Body Large/Regular" color="Brand/Blue">
          Clear LB
        </DS.Text>
      </Pressable>
      
      {/*<Pressable onPress={handleGenerateDeal}>
        <DS.Text variant="Body Large/Regular" color="Brand/Blue">
          Gen Deal
        </DS.Text>
      </Pressable>*/}

    </View>
    <View style={styles.adminRow}>
      <DS.Text variant="Body Large/Regular" color="Brand/Dark Grey" style={{ textAlign: "center" }}>
        Themes:{' '}
      </DS.Text>
       <Pressable onPress={()=>setTheme("default")}>
        <DS.Text variant="Body Large/Regular" color="Brand/Blue">
          Default
        </DS.Text>
      </Pressable>
      <Pressable onPress={()=>setTheme("purple")}>
        <DS.Text variant="Body Large/Regular" color="Brand/Blue">
          Purple
        </DS.Text>
      </Pressable>
      <Pressable onPress={()=>setTheme("green")}>
        <DS.Text variant="Body Large/Regular" color="Brand/Blue">
          Green
        </DS.Text>
      </Pressable>
    </View>
      <View style={styles.adminRow}>
      <DS.Text variant="Body Large/Regular" color="Brand/Dark Grey" style={{ textAlign: "center" }}>
        Themes:{' '}
      </DS.Text>
       <Pressable onPress={()=>setTheme("defaultImage")}>
        <DS.Text variant="Body Large/Regular" color="Brand/Blue">
          D Image
        </DS.Text>
      </Pressable>
      <Pressable onPress={()=>setTheme("purpleImage")}>
        <DS.Text variant="Body Large/Regular" color="Brand/Blue">
          P Image
        </DS.Text>
      </Pressable>
      <Pressable onPress={()=>setTheme("greenImage")}>
        <DS.Text variant="Body Large/Regular" color="Brand/Blue">
          G Image
        </DS.Text>
      </Pressable>
    </View>
    </>
  )

}

const styles = StyleSheet.create({
  adminRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 16,
    paddingTop: 8
  }
})

export { AdminControls, CthAdminControls, D10AdminControls, PocketPickAdminControls }
